var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaboration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.448 2.96798C15.9061 3.16684 16.1783 3.64392 16.1163 4.13948L15.2744 10.8749H23C23.4365 10.8749 23.8337 11.1275 24.0188 11.5228C24.204 11.9181 24.1437 12.3848 23.8643 12.7201L13.8643 24.7201C13.5445 25.1038 13.0102 25.2308 12.552 25.0319C12.0939 24.833 11.8218 24.356 11.8837 23.8604L12.7256 17.1249H5.00001C4.56349 17.1249 4.16638 16.8724 3.98123 16.4771C3.79607 16.0818 3.85631 15.6151 4.13576 15.2797L14.1358 3.27973C14.4555 2.89607 14.9899 2.76911 15.448 2.96798ZM7.40194 14.8749H14C14.3227 14.8749 14.6298 15.0135 14.8434 15.2554C15.057 15.4973 15.1564 15.8193 15.1163 16.1395L14.5923 20.3319L20.5981 13.1249H14C13.6773 13.1249 13.3702 12.9864 13.1566 12.7445C12.9431 12.5026 12.8437 12.1806 12.8837 11.8604L13.4078 7.66795L7.40194 14.8749Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/collaboration.6a7495b6ff843c9afdc8adce63994ab1.svg";
export { ForwardRef as ReactComponent };